<template>
    <nav class="flex justify-center gap-12 items-end text-white font-medium">
        <NavItem link="/"         text="Accueil"   :icon="HomeIcon" name="home" />
        <NavItem link="/steps"    text="Étapes"  :icon="ListBulletIcon" name="list" />
        <NavItem link="/map"      text="Carte"    :icon="MapIcon" name="map" :blink="props.blinkMap" />
    </nav>
</template>

<script setup>
import { defineProps } from 'vue'
import NavItem from '@/components/NavItem.vue'
import { HomeIcon, ListBulletIcon, MapIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
    blinkMap: {
        type: Boolean,
        default: false
    }
})
</script>

<style scoped>

</style>
